import { Entitlements } from '@protector/entities/licensing/constants';
import { getLicensingStatus, getSystemFlags } from 'core/core.selectors';
import { getHomePage } from 'core/utils/farm-home-page.utils';
import { validatePlansAndEntitlements } from 'core/utils/functions';
import { hasRTRPlanEntitlement, selectHasDiseaseRiskLandingPage } from 'entities/company/company.selectors';
import { useSelector } from 'react-redux';

export const useFarmHomePage = () => {
  const licensingStatus = useSelector(getLicensingStatus);
  const systemFlags = useSelector(getSystemFlags);
  const hasDiseaseRiskLandingPage = useSelector(selectHasDiseaseRiskLandingPage);
  const showOnlyNotesFeature = useSelector(hasRTRPlanEntitlement);
  const hasNemaPlanWithoutProtector =
    validatePlansAndEntitlements(licensingStatus, null, [Entitlements.NEMADIGITAL_WITHOUT_PROTECTOR]) &&
    (validatePlansAndEntitlements(licensingStatus, null, [Entitlements.SHOW_NEMA_MAP_VIEW_MFE]) ||
      !!systemFlags?.NEMA_1320_show_nema_map_view_mfe);

  return getHomePage({ hasDiseaseRiskLandingPage, showOnlyNotesFeature, hasNemaPlanWithoutProtector });
};
